import { render, staticRenderFns } from "./ByOs.vue?vue&type=template&id=1f33f184&scoped=true"
import script from "./ByOs.vue?vue&type=script&lang=js"
export * from "./ByOs.vue?vue&type=script&lang=js"
import style0 from "./ByOs.vue?vue&type=style&index=0&id=1f33f184&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f33f184",
  null
  
)

export default component.exports